import { render, staticRenderFns } from "./certificatePicture.vue?vue&type=template&id=02f20a55&scoped=true&"
import script from "./certificatePicture.vue?vue&type=script&lang=js&"
export * from "./certificatePicture.vue?vue&type=script&lang=js&"
import style0 from "./certificatePicture.vue?vue&type=style&index=0&id=02f20a55&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f20a55",
  null
  
)

export default component.exports